<template>
  <div class="flex flex-wrap mb-2" style="position:relative" :style="guideStep >= 7 && guideStep <= 12 && !isAreadlyOpenShowTargetKW ? { zIndex: 100 } : null">
    <loading :active="!this.showKeywordMix"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <div class="w-full lg:w-3/4 flex-1 min-w-0 bg-white rounded-xl space-y-6 p-3 lg:p-6">
      <div>
        <span v-if="this.targetKW" class="text-red-500">*</span>
        <span v-if="this.targetKW || this.targetAD" class="text-grap-700 align-middle">{{lang['components']['Event']['KeywordMix']['kw_title']}}</span>
        <span v-else class="text-grap-700 align-middle">{{lang['components']['Event']['KeywordMix']['not_kw_title']}}</span>
        <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip="'精準興趣廣告組合與關鍵字'"></i> -->
        <button
          v-if="!editPageType"
          id="keywordMix"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
          @click="teachVideo()"
        >
          {{lang['components']['Event']['KeywordMix']['video_teaching']}}
        </button>
      </div>
      <div class="flex-1 space-y-4">
        <div class="space-y-2">
          <div v-if="this.targetKW || this.targetAD">
            <span  class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['KeywordMix']['default_keyword']}}</span>
          </div>
          <div v-if="this.targetKW || this.targetAD" class="flex">
            <CascadeSelect
              :disabled="editPageType"
              v-model="defaultKeySelect"
              :options="viewDatalistData.base_keyword_list"
              optionLabel="cname"
              optionGroupLabel="name"
              :optionGroupChildren="['states', 'cities', 'district']"
              style="min-width: 14rem"
              class="w-1/4 rounded-md"
              :class="{ 'ring-4 border-blue-400': guideStep === 7 }"
              :placeholder="lang['components']['Event']['KeywordMix']['default_keyword_placeholder']"
              @change="defaultGetValue($event)"
            >
            </CascadeSelect>
          </div>
          <div>
            <span  class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['KeywordMix']['product_url_title']}}</span>
          </div>
          <div class="flex">
            <!-- 新手教學 -->
            <div class="bg-white rounded-md flex items-center w-5/6 p-2 shadow-sm border border-gray-200" :class="{ 'ring-4 border-blue-400': guideStep === 7 }">
              <input type="text" :disabled="editPageType" v-model="viewDatalistData.product_url" class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                :placeholder="lang['components']['Event']['KeywordMix']['product_url_title_placeholder']">
            </div>
            <button
              v-if="!editPageType && (this.targetKW || this.targetAD)"
              class="text-white px-4  ml-4 w-auto whitespace-no-wrap rounded-xl transition duration-300 bg-blue-900" @click="url_interests();">{{lang['components']['Event']['KeywordMix']['analyze_button_text']}}</button>
          </div>
          <!-- 新手教學 -->
          <div v-if="!editPageType && (this.targetKW || this.targetAD)" class="flex flex-wrap bg-white w-full p-2 rounded-md border" :class="{ 'ring-4 border-blue-400': guideStep === 8 || guideStep === 9 }">
            <template v-for="(tag, index) in urlKeywords" :key="tag.id">
              <!-- <div class="rounded m-1 px-2 py-1 text-sm cursor-pointer" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="tag.checked = !tag.checked">
                {{ tag.name }}
              </div> -->
              <div class="rounded m-1 px-2 py-1 text-sm cursor-pointer" :class="[
                tag.checked? tag.is_used == true ? 'bg-yellow-500' :'bg-blue-400' : tag.is_used == true ? 'bg-yellow-100' :' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="keywords_click(tag.checked, index, tag.code)">
                {{ tag.name }}
              </div>
            </template>
          </div>
          <div v-if="!editPageType && (this.targetKW || this.targetAD) && this.afterInterests" class="pt-8">
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['KeywordMix']['more_keywords_title']}}</span>
            <!-- 新手教學 -->
            <a class="text-blue-400 align-middle text-sm underline ml-4 cursor-pointer" :class="{ 'ring-4 border-blue-400': guideStep === 11 }" @click="suggest()">{{lang['components']['Event']['KeywordMix']['keywords_suggest_title']}} >></a>
          </div>
          <div v-if="!editPageType && (this.targetKW || this.targetAD) && this.afterInterests" class="flex flex-wrap bg-white w-full p-2 rounded-md border">
            <template v-for="(tag, index) in keywords_suggest" :key="tag.id">
              <!-- <div class="rounded m-1 px-2 py-1 text-sm cursor-pointer" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="tag.checked = !tag.checked">
                {{ tag.name }}
              </div> -->
              <div class="rounded m-1 px-2 py-1 text-sm cursor-pointer" :class="[
                tag.checked? tag.is_used == true ? 'bg-yellow-500' :'bg-blue-400' : tag.is_used == true ? 'bg-yellow-100' :' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="keywords_suggest_click(tag.checked, index, tag.code)">
                {{ tag.name }}
              </div>
            </template>
          </div>
          <div v-if="!editPageType && (this.targetKW || this.targetAD) && this.afterInterests" class="flex pt-4">
            <span class="text-grap-400 text-sm w-autor">{{lang['components']['Event']['KeywordMix']['search_keywords_info']}}</span>
            <!-- 新手教學 -->
            <div class="ml-4 w-full" :class="{ 'ring-4 border-blue-400': guideStep === 12 }">
              <div
                class="flex p-2 w-full bg-white rounded-md items-center shadow-sm border border-gray-200"
              >
                <i class="pi pi-search"></i>
                <input
                  :disabled="editPageType"
                  v-model="search_keyword"
                  type="search"
                  class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                  v-on:keyup="keyup_get_data();"
                />
              </div>
              <Listbox
                v-model="country"
                :options="countries"
                optionLabel="name"
                optionValue="code"
                class="mt-2 w-full rounded-md"
                emptyMessage="Loading..."
                v-if="search_keyword.length > 0"
              />
            </div>
            <!-- <div class=" bg-white rounded-md flex items-center w-full p-2 ml-4 shadow-sm border border-gray-200">
              <i class="pi pi-search"></i>
              <input type="search" class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent" v-model="search_keyword" v-on:keyup="test_keyup();">
            </div> -->
          </div>
          <!-- <Listbox v-model="country" :options="countries" optionLabel="name" optionValue="code" class="w-3/4 rounded-md"
            v-if="search_keyword.length > 0" /> -->
        </div>
      </div>
    </div>
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar">
      <div v-if="this.targetKW || this.targetAD" class="flex flex-col bg-white rounded-xl space-y-4 p-4">
        <span class="text-gray-700">{{lang['components']['Event']['KeywordMix']['select_keywords']}}</span>
        <span v-if="this.targetKW" class="text-gray-300 text-sm">{{lang['components']['Event']['KeywordMix']['select_keywords_num_info']}}</span>
        <span v-if="this.targetAD" class="text-gray-300 text-sm">{{lang['components']['Event']['KeywordMix']['ad_select_keywords_num_info']}}</span>
        <div class="flex flex-col bg-white w-full p-2 rounded-xl border h-48 overflow-y-auto">
          <template v-for="(tag, index) in viewDatalistData.keywords" :key="tag.id">
            <!-- <div class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="tag.checked = !tag.checked" v-if="tag.checked">
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" style="fontSize: 0.8rem"></i>
            </div> -->
            <div class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="un_select(tag.code)" v-if="tag.checked">
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" v-if="!editPageType" style="fontSize: 0.8rem"></i>
            </div>
          </template>
          <!-- <template v-for="(tag, index) in viewDatalistData.keywords" :key="tag.id">
            <div class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="tag.checked = !tag.checked" v-if="tag.checked">
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" style="fontSize: 0.8rem"></i>
            </div>
          </template>
          <template v-for="(tag, index) in keywords_suggest" :key="tag.id">
            <div class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="tag.checked = !tag.checked" v-if="tag.checked">
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" style="fontSize: 0.8rem"></i>
            </div>
          </template> -->
        </div>
      </div>
    </div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
  import CascadeSelect from "primevue/cascadeselect";
  import Listbox from 'primevue/listbox';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import Vue3DraggableResizable from 'vue3-draggable-resizable'
  import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'KeywordMix',
    components: {
      CascadeSelect,
      Listbox,
      Loading
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: -1
      },
      // <!-- 新手教學 -->
      editPage: {
        type: Boolean
      },
      targetKW: {
        type: Boolean
      },
      targetAD: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      itemsDatalist: {
        type: Object
      },
      lang: {
        type: Object
      },
      youtubeClose: {
        type: Boolean
      }
    },
    data() {
      return {
        tags: [{
            id: 1,
            text: '選擇關鍵字1',
            checked: false
          },
          {
            id: 2,
            text: '選擇關鍵字2',
            checked: false
          },
          {
            id: 3,
            text: '選擇關鍵字3',
            checked: false
          },
          {
            id: 4,
            text: '選擇關鍵字4',
            checked: false
          },
          {
            id: 5,
            text: '選擇關鍵字5',
            checked: true
          },
          {
            id: 6,
            text: '選擇關鍵字6',
            checked: false
          },
          {
            id: 7,
            text: '選擇關鍵字7',
            checked: false
          },
          {
            id: 8,
            text: '選擇關鍵字8',
            checked: false
          },
          {
            id: 9,
            text: '選擇關鍵字9',
            checked: false
          },
          {
            id: 10,
            text: '選擇關鍵字10',
            checked: false
          },
        ],
        moreTags: [{
            id: 1,
            text: '選擇更多關鍵字1',
            checked: false
          },
          {
            id: 2,
            text: '選擇更多關鍵字2',
            checked: false
          },
          {
            id: 3,
            text: '選擇更多關鍵字3',
            checked: false
          }
        ],
        defaultKeySelect: null,
        defaultKeyList: [
          {
              name: 'Australia',
              code: 'AU',
              states: [
                  {
                      name: 'New South Wales',
                      cities: [
                          {cname: 'Sydney', code: 'A-SY'},
                          // {cname: 'Newcastle', code: 'A-NE'},
                          {
                            name: 'Newcastle',
                            district: [
                              { cname: 'Newcastle Area 1', code: 'A-NE-1' },
                              { cname: 'Newcastle Area 2', code: 'A-NE-2' },
                              { cname: 'Newcastle Area 3', code: 'A-NE-3' }
                            ]
                          },
                          {cname: 'Wollongong', code: 'A-WO'}
                      ]
                  },
                  {
                      name: 'Queensland',
                      cities: [
                          {cname: 'Brisbane', code: 'A-BR'},
                          {cname: 'Townsville', code: 'A-TO'}
                      ]
                  },
                  {
                      cname: 'Test Area',
                      code: 'TA'
                  },
              ]
          },
          {
              name: 'Canada',
              code: 'CA',
              states: [
                  {
                      name: 'Quebec',
                      cities: [
                          {cname: 'Montreal', code: 'C-MO'},
                          {cname: 'Quebec City', code: 'C-QU'}
                      ]
                  },
                  {
                      name: 'Ontario',
                      cities: [
                          {cname: 'Ottawa', code: 'C-OT'},
                          {cname: 'Toronto', code: 'C-TO'}
                      ]
                  },

              ]
          },
          {
              name: 'United States',
              code: 'US',
              states: [
                  {
                      name: 'California',
                      cities: [
                          {cname: 'Los Angeles', code: 'US-LA'},
                          {cname: 'San Diego', code: 'US-SD'},
                          {cname: 'San Francisco', code: 'US-SF'}
                      ]
                  },
                  {
                      name: 'Florida',
                      cities: [
                          {cname: 'Jacksonville', code: 'US-JA'},
                          {cname: 'Miami', code: 'US-MI'},
                          {cname: 'Tampa', code: 'US-TA'},
                          {cname: 'Orlando', code: 'US-OR'}
                      ]
                  },
                  {
                      name: 'Texas',
                      cities: [
                          {cname: 'Austin', code: 'US-AU'},
                          {cname: 'Dallas', code: 'US-DA'},
                          {cname: 'Houston', code: 'US-HO'}
                      ]
                  }
              ]
          },
          {
              cname: 'Taiwan',
              code: 'TW'
          }
        ],
        search_keyword: '',
        keywords_suggest: [],
        urlKeywords: [],
        keywordsCheckedList: [],
        country: null,
        countries: null,
        selectCountries: [],
        mark_data: [],
        showKeywordMix: true,
        afterInterests: false,
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        src: "https://www.youtube.com/watch?v=VMMjP-UF6BY",
        vars: {
          rel: 0,
          start: 0,
          end: 0,
        },
        view_youtube: false,
      }
    },
    watch: {
      'youtubeClose':function(v){
      //  console.log('marketingmethod youtubeClose');
      //  console.log(v);

        let _tmpYoutubeType = v.split('_');

      //  console.log('_tmpYoutubeType');
      //  console.log(_tmpYoutubeType);

      //  console.log(typeof this.view_youtube);
      //  console.log(this.view_youtube);

        if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
          if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'keyword'){
            this.view_youtube = false
          }
        }

      //  console.log(typeof this.view_youtube);
      //  console.log(this.view_youtube);
      },
      country(v) {
      //  console.log('country');
      //  console.log(this.mark_data);
      //  console.log(v);
        var inArray = 0
        // console.log(this.keywords_suggest);

        for (let i = 0; i < this.keywords_suggest.length; i++) {
          if (this.keywords_suggest[i].code === v) {
            inArray = 1
          }
        }

        if(inArray == 0 && v != null){
          this.keywords_suggest.push(this.mark_data[v])
        }

        this.search_keyword = ''

        this.$emit('childKeywordUrl', v);
      },
      'viewDatalistData.product_url': function(v){
        // console.log('viewDatalistData.product_url:' + v);
        this.$emit('childKeywordUrl', v);
      },
      'viewDatalist.keyword_list': function(v){
      //  console.log('viewDatalistData.keyword_list:' + v);

        if(v != '' && v.length != null && typeof v != 'undefined'){
          if(v.length > 0){
            this.urlKeywords = v;

            this.afterInterests = true;
          }
        }
      },
      'targetAD': function(v){
      //  console.log('keywordMix targetAD');
      //  console.log(v);

        if(v == true){
          let itemLength = 0;

        //  console.log(this.viewDatalistData.keywords);

          for (let k = 0; k < this.viewDatalistData.keywords.length; k++) {
            if (this.viewDatalistData.keywords[k].checked == true) {
              itemLength = parseInt(itemLength) + parseInt(1);
            }
          }

          if(itemLength > 4){
            let _tmp_keywords = this.viewDatalistData.keywords;
            // this.viewDatalistData.keywords = _tmp_keywords.pop();
            _tmp_keywords.splice(_tmp_keywords.length - 1);
          }

        //  console.log(this.viewDatalistData.keywords);
        }
      }
    },
    methods: {
      onReady() {
      //  console.log('youtube');
        this.$refs.youtube.playVideo()
        // this.$refs.youtube.pauseVideo()
      },
      onStateChange(e){
      //  console.log(e);

        if(e.data == 0){
          this.view_youtube = false
        }
      },
      teachVideo(){
        this.$emit('checkClose')
        // let elem = document.getElementById('keywordMix');
        // let positio = this.getPosition(elem);
        // console.log('x:'+positio.x);
        // console.log('y:'+positio.y);

        // this.x = positio.x + parseInt(80);
        // this.y = positio.y

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;

        // console.log('windowWidth');
        // console.log(windowWidth);
        // console.log('windowHeight');
        // console.log(windowHeight);

        this.x = windowWidth - parseInt(390);
        this.y = windowHeight - parseInt(350);

        this.view_youtube = true;
        this.$emit('childYoutube', 'true_keyword')

        this.src = "https://www.youtube.com/watch?v=VMMjP-UF6BY"
        this.vars.start = 134
        this.vars.end = 239
      },
      getPosition(element) {
        let x = 0;
        let y = 0;

        while ( element ) {
          x += element.offsetLeft - element.scrollLeft + element.clientLeft;
          y += element.offsetTop - element.scrollLeft + element.clientTop;
          element = element.offsetParent;
        }

        return { x: x, y: y };
      },
      print(val) {
      //  console.log(val)
      },
      doDragging(){
      //  console.log('doDragging');
      },
      defaultGetValue(e){
      //  console.log(e);

        this.showKeywordMix = false;

        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_default_keywords.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            industry: e.value.code
          }))
          .then((response) => {
          //  console.log(response);
            if(response.data.status == 'success'){
              // this.urlKeywords = response.data.return_data
              // this.urlKeywords = this.urlKeywords.concat(response.data.return_data);

              if(this.urlKeywords.length > 0){
                if(response.data.return_data.length > 0){
                  for(let i = 0; i < response.data.return_data.length; i++){
                    let itemKeyStatus = false;
                    for(let j = 0; j < this.urlKeywords.length; j++){
                      if(response.data.return_data[i].code == this.urlKeywords[j].code){
                        itemKeyStatus = true;
                      }
                    }

                    if(itemKeyStatus == false){
                    //  console.log('#1');
                      this.urlKeywords.push(response.data.return_data[i]);
                    }
                  }
                }
              } else {
              //  console.log('#2');
                this.urlKeywords = this.urlKeywords.concat(response.data.return_data);
              }

            //  console.log(this.urlKeywords);

              // console.log(this.urlKeywords);
              this.$emit('childUrlKeywordsList', this.urlKeywords)
            }

            this.showKeywordMix = true;
            this.afterInterests = true;
            this.defaultKeySelect = null;
          });

        // var inArray = 0
        // console.log(this.urlKeywords);

        // for (let i = 0; i < this.urlKeywords.length; i++) {
        //   if (this.urlKeywords[i].code === e.value.code) {
        //     inArray = 1
        //   }
        // }

        // if(inArray == 0 && e.value.code != null){
        //   let selectKey = {name: e.value.cname, code: e.value.code, type: 'test', is_used: false, checked: false};
        //   this.urlKeywords.push(selectKey);
        // }

        // this.showKeywordMix = true;
        // this.afterInterests = true;
        // this.defaultKeySelect = null;
      },
      keywords_click(checked, index, code){
        let inItem = false
        let itemLength = 0
        let keyLimit = 5;

        if(this.targetAD == true){
          keyLimit = 4;
        }

        for (let k = 0; k < this.viewDatalistData.keywords.length; k++) {
          if (this.viewDatalistData.keywords[k].checked == true) {
            itemLength = parseInt(itemLength) + parseInt(1);
          }
        }

        if(checked == false){
          if(itemLength < keyLimit){
            for (let i = 0; i < this.viewDatalistData.keywords.length; i++) {
              if (this.viewDatalistData.keywords[i].code === code) {
                this.viewDatalistData.keywords[i].checked = true
                this.urlKeywords[index].checked = true
                inItem = true
              }
            }

            if(inItem == false){
              this.viewDatalistData.keywords.push({
                name: this.urlKeywords[index].name,
                code: code,
                type: this.urlKeywords[index].type,
                checked: true
              });
              this.urlKeywords[index].checked = true
            }
          } else {
            let swal_text = this.lang['components']['Event']['KeywordMix']['methods']['keywords_click']['swal_text'];

            if(this.targetAD == true){
              swal_text = this.lang['components']['Event']['KeywordMix']['methods']['keywords_click']['ad_swal_text'];
            }

            Swal.fire(
                      this.lang['components']['Event']['KeywordMix']['methods']['keywords_click']['swal_title'],
                      swal_text,
                      "error"
                    )
          }
        } else {
          for(let j = 0; j < this.urlKeywords.length; j++){
            if(this.urlKeywords[j].code === code){
              this.urlKeywords[j].checked = false
              for (let i = 0; i < this.viewDatalistData.keywords.length; i++) {
                if (this.viewDatalistData.keywords[i].code === code) {
                  this.viewDatalistData.keywords[i].checked = false
                }
              }
            }
          }
        }
      },
      keywords_suggest_click(checked, index, code){
        let inItem = false
        let itemLength = 0
        let keyLimit = 5;

        if(this.targetAD == true){
          keyLimit = 4;
        }

        for (let k = 0; k < this.viewDatalistData.keywords.length; k++) {
          if (this.viewDatalistData.keywords[k].checked == true) {
            itemLength = parseInt(itemLength) + parseInt(1);
          }
        }

        if(checked == false){
          if(itemLength < keyLimit){
            for (let i = 0; i < this.viewDatalistData.keywords.length; i++) {
              if (this.viewDatalistData.keywords[i].code === code) {
                this.viewDatalistData.keywords[i].checked = true
                this.keywords_suggest[index].checked = true
                inItem = true
              }
            }

            if(inItem == false){
              this.viewDatalistData.keywords.push({
                name: this.keywords_suggest[index].name,
                code: code,
                type: this.keywords_suggest[index].type,
                checked: true
              });
              this.keywords_suggest[index].checked = true
            }
          } else {
            let swal_text = this.lang['components']['Event']['KeywordMix']['methods']['keywords_suggest_click']['swal_text'];

            if(this.targetAD == true){
              swal_text = this.lang['components']['Event']['KeywordMix']['methods']['keywords_suggest_click']['ad_swal_text'];
            }

            Swal.fire(
                      this.lang['components']['Event']['KeywordMix']['methods']['keywords_suggest_click']['swal_title'],
                      swal_text,
                      "error"
                    )
          }
        } else {
          for(let j = 0; j < this.keywords_suggest.length; j++){
            if(this.keywords_suggest[j].code === code){
              this.keywords_suggest[j].checked = false
              for (let i = 0; i < this.viewDatalistData.keywords.length; i++) {
                if (this.viewDatalistData.keywords[i].code === code) {
                  this.viewDatalistData.keywords[i].checked = false
                }
              }
            }
          }
        }
      },
      un_select(code){
        if(this.editPageType == false){
          for (let i = 0; i < this.viewDatalistData.keywords.length; i++) {
            if (this.viewDatalistData.keywords[i].code === code) {
              this.viewDatalistData.keywords[i].checked = false

              for(let j = 0; j < this.urlKeywords.length; j++){
                if(this.urlKeywords[j].code === code){
                  this.urlKeywords[j].checked = false
                }
              }

              for(let j = 0; j < this.keywords_suggest.length; j++){
                if(this.keywords_suggest[j].code === code){
                  this.keywords_suggest[j].checked = false
                }
              }
            }
          }
        }
      },
      url_interests () {
        let Expression = /http(s)?:\/\/[\w-\.]+(:\d+)?(\/[\w\/\.]*)?(\?\S*)?(#\S*)?/g;
        let objExp = new RegExp(Expression);
        let input_url = this.viewDatalistData.product_url;
        if(objExp.test(input_url) != true){
          Swal.fire({
            icon: 'error',
            title: this.lang['components']['Event']['KeywordMix']['methods']['url_interests']['swal_title'],
            text: this.lang['components']['Event']['KeywordMix']['methods']['url_interests']['swal_text'],
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: this.lang['components']['Event']['KeywordMix']['methods']['url_interests']['confirm_button']
          }).then((result) => {
            this.viewDatalistData.product_url = '';
          })
        } else {
          this.showKeywordMix = false;
            axios
              .post('https://www.autoturn.net/api/customize/campaign/campaign_url_interests.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                url: input_url,
                special_ad_category: this.viewDatalistData.special_ad_category,
                keywords: this.viewDatalistData.keywords
              }))
              .then((response) => {
              //  console.log(this.urlKeywords);
              //  console.log(response);
                if(response.data.status == 'success'){
                  // this.urlKeywords = response.data.return_data
                  // this.urlKeywords = this.urlKeywords.concat(response.data.return_data);

                  if(this.urlKeywords.length > 0){
                    if(response.data.return_data.length > 0){
                      for(let i = 0; i < response.data.return_data.length; i++){
                        let itemKeyStatus = false;
                        for(let j = 0; j < this.urlKeywords.length; j++){
                          if(response.data.return_data[i].code == this.urlKeywords[j].code){
                            itemKeyStatus = true;
                          }
                        }

                        if(itemKeyStatus == false){
                        //  console.log('#1');
                          this.urlKeywords.push(response.data.return_data[i]);
                        }
                      }
                    }
                  } else {
                  //  console.log('#2');
                    this.urlKeywords = this.urlKeywords.concat(response.data.return_data);
                  }

                //  console.log(this.urlKeywords);

                  // console.log(this.urlKeywords);
                  this.$emit('childUrlKeywordsList', this.urlKeywords)
                }

                this.showKeywordMix = true;
                this.afterInterests = true;
              });
        }
      },
      suggest (){
        if(this.editPageType == false){
          this.showKeywordMix = false;

          // console.log('this.viewDatalistData.keywords');
          // console.log(this.viewDatalistData.keywords);

          let _tmp_keyword_ids = this.viewDatalistData.keywords

          if(_tmp_keyword_ids.length <= 0 || typeof _tmp_keyword_ids == 'undefined'){
            _tmp_keyword_ids = this.urlKeywords
          }

          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_form_keywords_suggest.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              special_ad_category: this.viewDatalistData.special_ad_category,
              keyword_ids: _tmp_keyword_ids,
              form_list: this.keywords_suggest
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                this.keywords_suggest = response.data.return_data
                this.$emit('update:itemsDatalist', response.data.return_data)

                this.$emit('childKeywordsSuggestList', this.keywords_suggest)
              }

              this.showKeywordMix = true;
            });
        }
      },
      keyup_get_data(){
        // console.log('search_keyword');
        // console.log(this.search_keyword);

        this.country = null
        this.countries = null

        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_keyword_search.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            special_ad_category: this.viewDatalistData.special_ad_category,
            q: this.search_keyword
          }))
          .then((response) => {
            // console.log(response);
            if(response.data.status == 'success'){
              this.countries = response.data.return_data
              this.mark_data = response.data.mark_data
            }
          });
      }
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      }
    }
  }
</script>
<style lang="scss" scope>

</style>